import type {VehicleAutocarisPlatformAdvertisingAttribute} from './VehicleAutocarisPlatformAdvertisingAttribute';

export type VehicleAutocarisPlatformAdvertisingSettings = {
  platformCode: VehicleAutocarisPlatformAdvertisingSettings.platformCode;
  enabled: boolean;
  attributes: Array<VehicleAutocarisPlatformAdvertisingAttribute>;
  hasOverrides: boolean;
  updatedAt: string | null;
  updatedBy: string | null;
};

export namespace VehicleAutocarisPlatformAdvertisingSettings {
  export enum platformCode {
    AUTOCARIS = 'autocaris',
  }
}
